var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrapper"},[(_vm.showPager)?_c('paginate',{attrs:{"page-count":_vm.pageCount,"page-range":_vm.pageRange,"margin-pages":_vm.marginPages,"click-handler":_vm.onPageClick,"prev-text":_vm.prevText,"next-text":_vm.nextText,"container-class":_vm.pagerContainerClass,"page-class":_vm.pagerPageClass}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }